export default "__VITE_ASSET__9hnXYjlo__"